// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-box-list {
    display: flex;
    flex-wrap: wrap;
    padding: 1.6rem;
    align-content: flex-start;
    overflow-y: auto;
}

.org-box-list > div {
    width: 250px;
    padding: 0.8rem;
    box-sizing: border-box;
}

.org-box-list > div > div {
    border-radius: 0.1rem;
    min-height: 250px;
    overflow: hidden;
    border: 1px solid var(--light);
}

.org-box-list > div > div .padding {
    padding: 0.8rem;
}

.org-box-list .img {
    width: 100%;
    height: 165px;
    background: var(--lighter);
    display: flex;
    align-items: center;
}

.org-box-list .img img {
    max-height: 80%;
    max-width: 80%;
    margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB","sourcesContent":[".org-box-list {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 1.6rem;\n    align-content: flex-start;\n    overflow-y: auto;\n}\n\n.org-box-list > div {\n    width: 250px;\n    padding: 0.8rem;\n    box-sizing: border-box;\n}\n\n.org-box-list > div > div {\n    border-radius: 0.1rem;\n    min-height: 250px;\n    overflow: hidden;\n    border: 1px solid var(--light);\n}\n\n.org-box-list > div > div .padding {\n    padding: 0.8rem;\n}\n\n.org-box-list .img {\n    width: 100%;\n    height: 165px;\n    background: var(--lighter);\n    display: flex;\n    align-items: center;\n}\n\n.org-box-list .img img {\n    max-height: 80%;\n    max-width: 80%;\n    margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
